import homepage from './homepage';
import release from './release';
import releaseAction from './release-action';
import settings from './settings';

export const controllers = {
  homepage,
  release,
  'release-action': releaseAction,
  settings,
};
